import { createFileRoute } from "@tanstack/react-router";

import { MembersLayout } from "@layouts/MembersLayout/members-layout";

export const Route = createFileRoute("/gs-admin/members")({
  component: MembersLayout,
});
